import dayjs from 'dayjs'
import { type CollectionIndex } from '../../../../models/peerToPeer/Collection'

/** "2025 - 2026" → "2025/2026" for the collection title; anything unparseable passes through. */
export const shortYearLabel = (yearLabel: string): string =>
  /\d{2,4}\s*[-/]\s*\d{2,4}/.exec(yearLabel)?.[0].replace(/\s/g, '').replace('-', '/') ?? yearLabel

/**
 * When the ISD last touched any building, including a save made in this session that the
 * index has not been refetched for yet.
 */
export const latestUpdatedAt = (index: CollectionIndex | null, liveSavedAt: string | null): string | null => {
  const dates = (index?.districts ?? [])
    .flatMap(district => district.buildings)
    .map(building => building.lastUpdatedAt)
    .filter((date): date is string => date != null)
  if (liveSavedAt != null) dates.push(liveSavedAt)
  if (dates.length === 0) return null
  return dates.reduce((latest, date) => dayjs(date).isAfter(dayjs(latest)) ? date : latest, dates[0])
}
